import ApiResourceManager from '../ApiResourceManager';

export default class ReportsManager extends ApiResourceManager {
  createIncomeReport = (data) =>
    this.request({
      method: 'POST',
      url: '/income-reports',
      responseType: 'blob',
      data,
    });

  createTaxReport = (data) =>
    this.request({
      method: 'POST',
      url: '/tax-reports',
      responseType: 'blob',
      data,
    });

  getSalesSummary = (params) =>
    this.request({
      method: 'GET',
      url: '/sales-summary',
      params,
    });
}
